import { getSessionDetails } from "../state";

type Identities = "UserBrowserId" | "SessionId" | "ExpertId" | "CallSid" | "EmpId";

export type IdentitiesObj = Partial<Record<Identities, string>>;

export const getIdentities = (): [IdentitiesObj, Record<string, unknown>] => {
    const { sessionId, expertId, callSid, partner, lob } = getSessionDetails();
    let identities: IdentitiesObj = {};
    if (sessionId) {
        identities = { ...identities, SessionId: sessionId };
    }
    if (expertId) {
        identities = { ...identities, ExpertId: expertId, EmpId: expertId };
    }
    if (callSid) {
        identities = { ...identities, CallSid: callSid };
    }
    return [identities, { partner, lob }];
};
